<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content >
     
      <div class="deactive_acctrt">
        <!-- <p>Before you go, please leave some quick feedback to help improve our service:</p> -->
         <!-- <h3>
          If you still want to De-Activate your account
       </h3> -->
         <p> If you want to de-activate your account, please let us know the reason for such decision. It will help us improve our services. Not only the personal data will be erased from a de-activated account, you are going to loose the business data as well.</p>
        <mat-form-field appearance="outline">
          <mat-label>Reason</mat-label>
          <textarea
          [(ngModel)]="message"
            matInput
          ></textarea>
        </mat-form-field>
      </div>
      
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <mat-dialog-actions align="end" style="margin-top: -20px;">
    <button
    mat-flat-button
    color="accent" style="color: #fff;">Keep my account
  </button>
    <button mat-button (click)="deactivate()" class="deacv">De-activate anyway</button>
  
  </mat-dialog-actions>
  